export const getNewSelection = (selectedOption: string, selectedOptions: string[]) => {
  if (selectedOptions.includes(selectedOption)) {
    return selectedOptions.filter((o) => o !== selectedOption);
  }
  return [...selectedOptions, selectedOption];
};
